import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import {
  catchError,
  from,
  map,
  Observable,
  of,
  switchMap,
  throwError,
} from 'rxjs';
import Keycloak from 'keycloak-js';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private keycloak = inject(Keycloak);
  private router = inject(Router);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!this.keycloak.authenticated) {
      return next.handle(request);
    }

    return this.getActualToken().pipe(
      switchMap((token) => {
        if (!token) {
          return next.handle(request);
        }

        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        });

        return next.handle(authReq);
      }),
    );
  }

  private getActualToken(): Observable<string | undefined> {
    const minValiditySeconds = 30;

    const refreshToken$ = this.keycloak.isTokenExpired(minValiditySeconds)
      ? from(this.keycloak.updateToken(minValiditySeconds))
      : of(false);

    return refreshToken$.pipe(
      map(() => this.keycloak.token),
      catchError((error) => {
        this.keycloak.clearToken();
        this.router.navigate(['/login']);

        return throwError(() => error);
      }),
    );
  }
}
